if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      let optionChecked = false
       if ( document.querySelector('.card-upsell-popover').hasAttribute('open')) {
       const popupOptions = evt.target.closest('.popup-product-details')?.querySelectorAll(".variant-radios-wrapper input")
       popupOptions?.forEach((ele) => {
          if (ele.checked){
             optionChecked = true
          }
       })
       }
      if ( !document.querySelector('.card-upsell-popover').hasAttribute('open')) {
       const variantOptions = evt.target.closest('.product__info-wrapper ')?.querySelectorAll(".variant-radios-wrapper input");
       variantOptions?.forEach((ele) => {
          if (ele.checked){
             optionChecked = true
          }
       })
      }
      
      const hasVariant = document.querySelector('.variant-radios-wrapper input[type="radio"]') || document.querySelector('variant-radios input[type="radio"]');
      const selectedVariant = document.querySelector('.variant-radios-wrapper input[type="radio"]:checked') || document.querySelector('variant-radios input[type="radio"]:checked')
      const warningMsg = document.querySelector('.variant-warning-msg');
      const popupWarningMsg = document.querySelector('.popup-variant-warning-msg')
      const removeBackgroundOverlay =  document.querySelector('.popup-overlay');
      const noVariant = evt.target.querySelector('.product-form__button')?.getAttribute('data-variant');
  
      if ((!hasVariant || selectedVariant && (selectedVariant.hasAttribute("value")) && optionChecked || noVariant )){
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.stickyButton?.setAttribute('aria-disabled', true);
        this.stickyButton?.classList.add('loading');
        this.querySelector('.quick-icon-svg')?.classList.add('hidden')
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        warningMsg?.classList.add('hidden')
        popupWarningMsg?.classList.add('hidden')
        removeBackgroundOverlay.classList.remove('popup-background-shadow')
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);

          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // truncate the error message in the variant
              let truncatedDescription = response.description || ''; 
              const indexOfSymbol = truncatedDescription.indexOf('{');

              // turncate the message starting charcater is {
              if (indexOfSymbol !== -1) {
                truncatedDescription = truncatedDescription.substring(0, indexOfSymbol);
              } else {
                truncatedDescription = truncatedDescription || '';
              }
              this.handleErrorMessage(truncatedDescription);  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              if (this.querySelector("button").classList.contains("popup-add-to-cart")) {
                document.querySelector("#popover-container").removeAttribute("open");
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.querySelector('.quick-icon-svg')?.classList.remove('hidden')
            this.stickyButton?.removeAttribute('aria-disabled');
            this.stickyButton?.classList.remove('loading');
          });
      } else {
        popupWarningMsg?.classList.remove('hidden');
        if (!document.querySelector('.card-upsell-popover').hasAttribute('open')) {
          warningMsg?.classList.remove('hidden');
          if (navigator.vibrate) {
            navigator.vibrate(300);
          }
          window.scrollTo({ top: 50, behavior: 'smooth' });
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      let stickyerrorwrapper  = document.querySelector(".sticky-product-form__error-message-wrapper");
      let stickyerrormessage = document.querySelector(".sticky-product-form__error-message");
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
     
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      stickyerrorwrapper?.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        stickyerrormessage.textContent = errorMessage;
      }
    }
  });


}

